import { lazy, Suspense, type FC } from "react";
import { twMerge } from "tailwind-merge";
import type { ProseEditorProps } from "./proseEditor.js";

// CodeMirror is heavy, so it loads in its own chunk on first use.
const ProseEditor = lazy(() =>
  import("./proseEditor.js").then((module) => ({
    default: module.ProseEditor,
  })),
);

/** Shows an empty box of the same size while the editor loads. */
export const LazyProseEditor: FC<ProseEditorProps> = (props) => {
  const { variant, isReadOnly, className } = props;

  return (
    <Suspense
      fallback={
        <div
          className={twMerge(
            "rounded-md border border-border-strong bg-white shadow-xs",
            variant === "input" ? "h-8" : "min-h-[38px]",
            isReadOnly && "bg-slate-50",
            className,
          )}
        />
      }
    >
      <ProseEditor {...props} />
    </Suspense>
  );
};
